import { InventoryGroup } from "./inventory-group";
import { InventoryUserType } from "./inventory-user-type";

export class InventoryQueryParams {
  groups: InventoryGroup[] = [];
  userType: InventoryUserType = new InventoryUserType();
  brands: string[] = [];
  nonParallelsOptionSelected: boolean = true;
}
